<template>
    <page showBackButton>
        <h2>Diese Seite wurde leider nicht gefunden.</h2>
        <p>
            Möglicherweise wurde die Seite verschoben oder sie existiert nicht.
        </p>
        <p v-if="capacitor.isNative">
            Vielleicht hast du auch eine alte App Version installiert. Überprüfe
            die App bitte auf Updates im
            <a
                :href="
                    capacitor.platform === 'android'
                        ? 'https://play.google.com/store/apps/details?id=at.wuestenrot.klickmal.app'
                        : 'https://apps.apple.com/at/app/id1501348909'
                "
                target="_blank"
                >{{
                    capacitor.platform === "android"
                        ? "Google Play Store"
                        : "Apple App Store"
                }}</a
            >.
        </p>
        <img class="ion-margin-top" src="../assets/img/kamel_error.png" />
    </page>
</template>

<script>
import Page from "@/components/Page";

export default {
    components: {
        Page,
    },
    data() {
        return {
            capacitor: Capacitor,
        };
    },
    mounted() {
        // this.capacitor.isNative = true;
        // this.capacitor.platform = "android";
    },
};
</script>

<style></style>
